/* VENERE SHOP - checkout diretto dalla scheda prodotto. Verificare su anteprima. */
(function () {
  if (window.venereCheckoutInitialized) return;
  window.venereCheckoutInitialized = true;
  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-venere-checkout]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled) return;
    const form = button.closest('form');
    if (!form) return;
    const nativeButton = form.querySelector('[data-add-to-cart]');
    const id = form.querySelector('input[name="id"]');
    if (!id || !id.value || (nativeButton && nativeButton.disabled)) {
      window.alert('Seleziona una taglia disponibile prima di procedere.');
      return;
    }
    const text = button.querySelector('[data-venere-checkout-label]');
    const originalText = text ? text.textContent : '';
    button.disabled = true;
    if (text) text.textContent = 'CARICAMENTO...';
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: {'Accept':'application/json'}
      });
      if (!response.ok) {
        const data = await response.json().catch(function(){return {}});
        throw new Error(data.description || data.message || 'Impossibile aggiungere il prodotto');
      }
      window.location.assign('/checkout');
    } catch (err) {
      window.alert(err.message || 'Si e verificato un errore, riprova.');
      button.disabled = false;
      if (text) text.textContent = originalText;
    }
  });
})();
